import * as Yup from 'yup';

export const AssignPaymentConfirmationValidationSchema = () =>
	Yup.object().shape({
		amount: Yup.number()
			.min(0.01, "Returned value can't be lower than 0.01.")
			.nullable(),
	});
